export default __webpack_public_path__ + "static/elbow-hero-video-23d471ecac841cdd581fdffdb0f6d9ae.jpg";